import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import ErrorModal from "../Security/ErrorModal"; // Import the modal
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';

const Benefits_TreatmentCostEstimator = () => {
    const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [packageList, setPackageList] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedPackageName, setSelectedPackageName] = useState(null);
  const [providerDetails, setProviderDetails] = useState({});
  const token = localStorage.getItem('AccessToken');
  const contract = useSelector((state) => state.userData.userData.ContractIdentified);
  const memberid = useSelector((state) => state.userData.userData.MemberID);
  const [showModal, setShowModal] = useState(false); // Modal visibility
  const [modalMessage, setModalMessage] = useState(""); // Modal message
  const navigate = useNavigate();
  const {isChatVisible, toggleChat, showChat } = useChat();
  const emailid = useSelector((state) => state.userData.userData.EmailID);

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  useEffect(() => {
    const fetchPackageList = async () => {
            const params = {
        MemberID: memberid,
        Contract: contract,
        DeviceType:isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        EmailID:emailid
      };

      setLoading(true);
      try {
        const response = await axios.post(
          Endpoints.GetTreatmentPackageList,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data) {
          setPackageList(response.data.PackageListoutput || []);
          setProviderDetails(response.data.FavouriteGroupDetails || {});
        }
      } catch (error) {
        console.error("Error fetching package list:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPackageList();
  }, []);

  const handlePackageSelection = (changespackage) => {
    setSelectedPackage(changespackage.CPTCode);
    setSelectedPackageName(changespackage.Package)

  };

  const handleSubmit = () => {
    if (selectedPackage==null) {
      setModalMessage(t("modalmessagetreatment"));
      setShowModal(true);
      return;
    }
    if (selectedPackage && selectedPackageName) {
      // Redirect to the Treatment Package component
      navigate("/benefits-treatmentpackages", { state: { selectedPackage,providerDetails,selectedPackageName } });
    } else {
    //   alert("Please select a treatment package.");
    }
  };

   if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }
  const handleBackClick = () => {
    navigate(-1); // Redirects to the home page
  };
  const handleOkClick = () => {
    // Logic for when "OK" is clicked
    setShowModal(false);
  };
  return (
    <>

{isHighmarkPortal ? 
            <div className="col-md-12 col-lg-6 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={() => navigate(-1)}>
                <span>
                <i className="bi bi-chevron-left"></i>
                </span>
            </button>       
            <h2 className="page-heading">{t('treatmentcost')}</h2>
            </div>:
            <div className="col-md-12 col-lg-6 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={() => navigate(-1)}>
                <span>
                <i className="bi bi-chevron-left"></i>    
                {t('Back')}        
                </span>
            </button>       
            <h2 className="page-heading">{t('treatmentcost')}</h2>
            </div>
          }

      {/* <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> {t('back')}</span></button>
        <h1 className="page-heading">{t('treatmentcost')}</h1>
      </div> */}

      <div className="col-12 mt-5">
        {/* Provider Details Section */}
        <div className="row g-5">
          <div className="col-md-12 col-lg-6 mt-4">
            {providerDetails.GroupName ? (
              <>
                <h4 className="page-heading-secondary-gray mb-4">{t('selectedprovider')}</h4>

                <div className="provider-wrapper">
                  <h2 className="page-heading-bold-primary-20">{providerDetails.GroupName}</h2>
                  <p>{providerDetails.Address}</p>
                  <button className="win-btn-secondary-w-content highmark-option-text-underline d-flex align-items-center mt-0 mt-md-5"
                    onClick={() =>
                      navigate("/map-search", {
                        state: {
                          selectedProviderType:
                            "Reproductive Endocrinologists/Infertility",
                        },
                      })
                    }
                  >
                    {t('changeprovider')}
                  </button>
                </div>
                
              </>
            ) : (
              <>
                <h4 className="page-heading-secondary-gray mb-4">{t('notselectedprovider')}</h4>

                <div className="provider-wrapper">
                  <button className="win-btn-secondary-w-content highmark-option-text-underline d-flex align-items-center mt-0 mt-md-5"
                    onClick={() =>
                      navigate("/map-search", {
                        state: {
                          selectedProviderType:
                            "Reproductive Endocrinologists/Infertility",
                        },
                      })
                    }
                  >
                    {t('specificresults')}
                  </button>
                </div>                
              </>
            )}
          </div>
        
      

      
  
          {/* Treatment Package Section */}
          <div className="col-md-12 col-lg-6 mt-4">
            <h4 className="page-heading-secondary-gray mb-4">{t('treatmentpackage1')}</h4>
           <div className="form-group">
          {packageList.map((item, index) => (
            <div key={index} className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="treatmentPackage"
                id={`package-${index}`}
                value={item.CPTCode}
                checked={selectedPackage === item.CPTCode}
                onChange={() => handlePackageSelection(item)}
              />
        <label className="form-check-label" htmlFor={`package-${index}`}>
          {item.Package}
        </label>
      </div>
              ))}
            </div>

            <button  className="win-btn-primary mobile-view mt-5 mx-auto mx-md-0 d-block mb-5" onClick={handleSubmit}>
              {t('submit')}
            </button>
          </div>
        </div>
      </div>
      <ErrorModal
        show={showModal}
        message={modalMessage}
        onClose={() => setShowModal(false)}
        onOkay={handleOkClick}
      />
    </>
  );
  
};

export default Benefits_TreatmentCostEstimator;
